import React, { useEffect } from "react";
import CustomerEditComp from "../Components/CustomerEdit/CustomerEdit";
const CustomerEdit = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <CustomerEditComp />
    </div>
  );
};

export default CustomerEdit;
